import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

import { computed, nextTick, onMounted, ref } from 'vue';
import { IKhoResponseBase, ITongHopVatTuTheoDoiTuongResponseBase } from '@/core/interfaces/ApiResponses';
import { useButtonCustom } from '@/core/hooks/use-button-custom';
import { setCurrentPageTitle } from '@/core/helpers/breadcrumb';
import { useCreatingForm } from '@/core/hooks/use-creating-form';
import { useDateTime } from '@/core/hooks/use-date-time-hook';
import { useLoading } from '@/core/hooks/use-loading';
import { useStore } from 'vuex';
import { KhoService } from '@/core/services/Kho.service';
import { swalErrNotification } from '@/core/helpers/utils';
import { BaoCaoService } from '@/core/services/BaoCao.service';
import DivCol from '@/layout/_shared/DivCol.vue';
import DivRow from '@/layout/_shared/DivRow.vue';
import LabelCustom from '@/components/shared/label-custom/LabelCustom.vue';
import PageRowLayout from '@/layout/_shared/PageRowLayout.vue';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TongHopVatTuTheoDoiTuong',
  setup(__props) {

setCurrentPageTitle('Báo cáo');

const { startLoading, endLoading } = useLoading();

const { formRef } = useCreatingForm();

const printModal = ref();

const store = useStore();

const { defaultDate, disableDate, formatDisplayingDate } = useDateTime();

const currentYear = computed(() => store.getters.getSelectedYear);

const khoItems = ref<IKhoResponseBase[]>([]);

const { ButtonsType, ButtonTypeColors } = useButtonCustom();

const form = ref({
  khoId: -1,
  date: defaultDate.value,
});

const fetchKhoItems = async () => {
  await startLoading();

  try {
    const { data: { data: { data } } } = await KhoService.fetchAllWarehouses();

    khoItems.value = data;

    await endLoading();
  } catch (e) {
    await endLoading();

    await swalErrNotification(e, 'Có lỗi khi lấy danh sách kho');
  }
}

onMounted(() => {
  nextTick(async () => {
    await fetchKhoItems();
  });
});

const isFiltersChanging = ref(true);

const selectingKho = computed(() => {
  if (!form.value.khoId) return null;

  return khoItems.value.find(({ id }) => id === form.value.khoId);
});

const rules = {
  khoId: [
    {
      type: 'number',
      message: 'Phải chọn kho',
      trigger: 'change',
      min : 1,
    }
  ],
  date: [
    {
      type: 'date',
      message: 'Phải chọn ngày',
      trigger: 'change',
      required: true,
    }
  ]
}

const resultItems = ref<ITongHopVatTuTheoDoiTuongResponseBase[]>([]);

const generate = () => {
  if (!formRef.value) return;

  formRef.value.validate(async (isValid: boolean) => {
    if (isValid) {
      isFiltersChanging.value = false;

      await startLoading();

      try {
        const {
          data: {
            data: res
          }
        } = await BaoCaoService.getTongHopVatTuTheoDoiTuong({
          kho_id: form.value.khoId ?? 1,
          month: form.value.date.getMonth() + 1
        });

        resultItems.value = res;

        await endLoading();
      } catch (e) {
        await endLoading();

        await swalErrNotification(e, 'Có lỗi xảy ra');
      }
    } else return false;
  });
}

const showPrintButton = computed(() => {
  if (isFiltersChanging.value) return false;

  if (!resultItems.value.length) return false;

  return !(!selectingKho.value || !form.value.date);
});

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(PageRowLayout, null, {
    "page-row-header": _withCtx(() => [
      _createTextVNode(" Tổng hợp vật tư theo đối tượng ")
    ]),
    "page-row-content": _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: form.value,
        rules: rules,
        onSubmit: _withModifiers(generate, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(DivRow, { class: "mb-5" }, {
            default: _withCtx(() => [
              _createVNode(DivCol, {
                cols: 2,
                "additional-class": "d-flex align-items-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(LabelCustom, {
                    "is-text-muted": true,
                    "is-required": true
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Đến tháng: ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DivCol, { cols: 3 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "to",
                    class: "mb-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: form.value.date,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.date) = $event)),
                        class: "w-100",
                        "disabled-date": (time) => _unref(disableDate)(time, currentYear.value, true),
                        type: "month",
                        placeholder: "đến",
                        name: "to",
                        format: "MM/YYYY"
                      }, null, 8, ["modelValue", "disabled-date"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(DivRow, { class: "mb-5" }, {
            default: _withCtx(() => [
              _createVNode(DivCol, {
                cols: 2,
                class: "d-flex align-items-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(LabelCustom, {
                    "is-text-muted": true,
                    "is-required": true
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Kho:")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DivCol, { cols: 3 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "khoId",
                    class: "mb-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: form.value.khoId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.khoId) = $event)),
                        class: "w-100",
                        name: "khoId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            disabled: "",
                            label: "Chọn kho",
                            value: -1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(khoItems.value, (kho) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: kho.id,
                              label: kho.ten_kho,
                              value: kho.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(DivRow, null, {
            default: _withCtx(() => [
              _createVNode(DivCol, { cols: 8 }),
              _createVNode(DivCol, {
                cols: 4,
                class: "d-flex justify-content-end"
              }, {
                default: _withCtx(() => [
                  (showPrintButton.value)
                    ? (_openBlock(), _createBlock(ButtonCustom, {
                        key: 0,
                        "button-type": _unref(ButtonsType).FA_PRINT,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (printModal.value.isOpen = true))
                      }, {
                        "button-label": _withCtx(() => [
                          _createTextVNode("In phiếu")
                        ]),
                        _: 1
                      }, 8, ["button-type"]))
                    : _createCommentVNode("", true),
                  _createVNode(ButtonCustom, {
                    "button-type": _unref(ButtonsType).FA_FILE_EXPORT_THIN,
                    "color-type": _unref(ButtonTypeColors).SUCCESS,
                    onClick: generate
                  }, null, 8, ["button-type", "color-type"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }))
}
}

})